import React from 'react';
import { Modal, Button } from 'semantic-ui-react';
import './style.css';

export const AppSumoDetailsModal = ({ isVisible, onClose, numberOfCodes }) => {
  if (!isVisible || !numberOfCodes || numberOfCodes > 10) {
    return null;
  }

  const simpleFeatures = [
    'Unlimited custom video collection campaigns',
    'Remote video capturing (phone, tablet, & desktop)',    
    'Multiple prompts',    
    'Custom video rights management',    
    'Video hosting, transcoding, and encryption',    
    'Download videos',    
    'Capture user lead info',    
    'Tagging & filtering videos for easy use',    
    'Reply to submission directly from VideoPeel',    
    'Video submission notifications',    
    'Collect photos',    
    'Customized thank you page with links and Calls to Action (Google, FB, or Amazon)',    
    'Publish videos (dynamic video carousel plugin)',    
    'Video syndication (YouTube, Facebook)',    
    'Campaign templates (profile, image, or video)',    
    'Video transcriptions',    
    "Ability to recruit from VideoPeel's Consumer Video Network (coming soon, will require an additional charge for us to do the recruiting)",
    'Video editing (coming soon)',
    'Zapier integration (coming soon)',    
  ];

  const allfeatures = [
    'Unlimited custom video collection campaigns',
    'Remote video capturing (phone, tablet, & desktop)',
    'Multiple prompts',
    'Custom video rights management',
    'Video hosting, transcoding, and encryption',
    'Download videos',
    'Capture user lead info',
    'Tagging & filtering videos for easy use',
    'Reply to submission directly from VideoPeel',
    'Video submission notifications',
    'Collect photos',
    'Customized thank you page with links and Calls to Action (Google, FB, or Amazon)',
    'Publish videos (dynamic video carousel plugin)',
    'Video syndication (YouTube, Facebook, Amazon)',
    'Campaign templates (profile, image, or video)',
    'Video transcriptions',
    'Multi-user',
    'Customizable Campaign and Video URLs',
    'White-label Video Carousel Player',
    "Ability to recruit from VideoPeel's Consumer Video Network (coming soon, will require an additional charge for us to do the recruiting)",
    'Video editing (coming soon)',
    'Zapier integration (coming soon)',
  ];

  const commonDealTerms = [
    'Lifetime access to VideoPeel (Pro Plan features)',
    'All future plan updates (Pro Plan)',
  ];

  const featuresByAmountOfCodes = {
    1: {
      dealTerms: [...commonDealTerms, '50 Videos Per month'],
      featuresIncluded: simpleFeatures,
    },
    2: {
      dealTerms: [...commonDealTerms, '100 Videos Per month'],
      featuresIncluded: simpleFeatures,
    },
    3: {
      dealTerms: [...commonDealTerms, '200 Videos Per month'],
      featuresIncluded: allfeatures,
    },
    4: {
      dealTerms: [...commonDealTerms, '250 Videos Per month'],
      featuresIncluded: allfeatures,
    },
    5: {
      dealTerms: [...commonDealTerms, '300 Videos Per month'],
      featuresIncluded: allfeatures,
    },
    6: {
      dealTerms: [...commonDealTerms, '350 Videos Per month'],
      featuresIncluded: allfeatures,
    },
    7: {
      dealTerms: [...commonDealTerms, '400 Videos Per month'],
      featuresIncluded: allfeatures,
    },
    8: {
      dealTerms: [...commonDealTerms, '450 Videos Per month'],
      featuresIncluded: allfeatures,
    },
    9: {
      dealTerms: [...commonDealTerms, '500 Videos Per month'],
      featuresIncluded: allfeatures,
    },
    10: {
      dealTerms: [...commonDealTerms, '550 Videos Per month'],
      featuresIncluded: allfeatures,
    },
  };

  return (
    <Modal
      open
      closeOnEscape
      closeOnDimmerClick
      onClose={onClose}
      dimmer='inverted'
      size='tiny'
      className='appsumo-details-modal-container'
    >
      <Modal.Content className='appsumo-details-modal-content' scrolling>
        <h1>Deal Terms</h1>
        <ul>
          {featuresByAmountOfCodes[numberOfCodes].dealTerms.map((term) => (
            <li>{term}</li>
          ))}
        </ul>
        <h1>Features Included</h1>
        <ul>
          {featuresByAmountOfCodes[numberOfCodes].featuresIncluded.map(
            (feature) => (
              <li>{feature}</li>
            )
          )}
        </ul>
        <p className='appsumo-details-modal-learn'>
          To learn about how to use each of your features check out our learning
          center:
          <a
            href='https://learn.videopeel.com/en/'
            target='_blank'
            rel='noopener noreferrer'
          >
            {' learn.videopeel.com'}
          </a>
        </p>
      </Modal.Content>
      <Modal.Actions>
        <Button content='Ok' onClick={onClose} primary />
      </Modal.Actions>
    </Modal>
  );
};



// WEBPACK FOOTER //
// ./src/components/AppSumoDetailsModal/index.jsx